"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const independent_living_service_1 = require("../services/independent-living.service");
const accommodation_preferences_service_1 = require("../services/accommodation-preferences.service");
const Models_1 = require("../Models");
const dnaRSnackBar_service_1 = require("../../common/dna-r/dnaRSnackBar.service");
const rxjs_1 = require("rxjs");
const ilu_leads_dashboard_dto_1 = require("../dtos/ilu-leads-dashboard-dto");
const ilu_leads_dashboard_filter_dto_1 = require("../dtos/ilu-leads-dashboard-filter-dto");
require("../dtos/facility-dto");
require("../dtos/accommodation-type-dto");
require("../dtos/tag-dto");
const enquiry_accessibility_requirement_enum_1 = require("../enums/enquiry-accessibility-requirement.enum");
const enquiryAccessibilityRequirementDescription_pipe_1 = require("../../common/pipes/enquiryAccessibilityRequirementDescription.pipe");
const ILU_status_enum_1 = require("../enums/ILU-status.enum");
const batch_result_1 = require("../../common/dto/batch-result");
require("../dtos/lead-card-dto");
const ilu_leads_dashboard_state_enum_1 = require("./ilu-leads-dashboard-state.enum");
const angular_1 = require("@uirouter/angular");
const ilu_leads_dashboard_filter_1 = require("./ilu-leads-dashboard-filter");
require("../models/lead-card");
require("../dtos/simple-enquiry-dto");
const i0 = require("@angular/core");
const i1 = require("../services/independent-living.service");
const i2 = require("../services/accommodation-preferences.service");
const i3 = require("../../common/dna-r/dnaRSnackBar.service");
const i4 = require("@uirouter/angular");
const i5 = require("@angular/common");
const i6 = require("../../common/components/dnaR-back-to-top/dnaR-back-to-top.component");
const i7 = require("../../common/components/dnaR-dropdown-multiSelect/dnaR-dropdown-multiSelect.component");
const i8 = require("@angular/cdk/drag-drop");
const i9 = require("./ilu-leads-dashboard-column.component");
function ILULeadsDashboardComponent_a_6_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 11);
    i0.ɵɵlistener("click", function ILULeadsDashboardComponent_a_6_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.openFilterDrawer(); });
    i0.ɵɵelement(1, "span", 12);
    i0.ɵɵtext(2, "Show filters");
    i0.ɵɵelementEnd();
} }
function ILULeadsDashboardComponent_a_7_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 11);
    i0.ɵɵlistener("click", function ILULeadsDashboardComponent_a_7_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.closeFilterDrawer(); });
    i0.ɵɵelement(1, "span", 12);
    i0.ɵɵtext(2, "Hide and reset filters");
    i0.ɵɵelementEnd();
} }
function ILULeadsDashboardComponent_a_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 13);
    i0.ɵɵelement(1, "span", 14);
    i0.ɵɵtext(2, "New enquiry");
    i0.ɵɵelementEnd();
} }
function ILULeadsDashboardComponent_div_12_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "label");
    i0.ɵɵtext(2, "Location");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "dnaR-dropdown-multiSelect", 23);
    i0.ɵɵlistener("initialSelectedItemsChange", function ILULeadsDashboardComponent_div_12_div_2_Template_dnaR_dropdown_multiSelect_initialSelectedItemsChange_3_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(2); return ctx_r12.filter.facilityLocations = $event; });
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("placeholder", "Select location/s")("settings", ctx_r11.filterDropdownSettings)("data", i0.ɵɵpipeBind1(4, 4, ctx_r11.facilityLocations$))("initialSelectedItems", ctx_r11.filter.facilityLocations);
} }
function ILULeadsDashboardComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "div", 16);
    i0.ɵɵtemplate(2, ILULeadsDashboardComponent_div_12_div_2_Template, 5, 6, "div", 17);
    i0.ɵɵelementStart(3, "div", 18);
    i0.ɵɵelementStart(4, "label");
    i0.ɵɵtext(5, "Unit type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "dnaR-dropdown-multiSelect", 19);
    i0.ɵɵlistener("initialSelectedItemsChange", function ILULeadsDashboardComponent_div_12_Template_dnaR_dropdown_multiSelect_initialSelectedItemsChange_6_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.filter.unitTypes = $event; });
    i0.ɵɵpipe(7, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 18);
    i0.ɵɵelementStart(9, "label");
    i0.ɵɵtext(10, "Mobility");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "dnaR-dropdown-multiSelect", 20);
    i0.ɵɵlistener("initialSelectedItemsChange", function ILULeadsDashboardComponent_div_12_Template_dnaR_dropdown_multiSelect_initialSelectedItemsChange_11_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.filter.accessibilityRequirements = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 18);
    i0.ɵɵelementStart(13, "label");
    i0.ɵɵtext(14, "Tag");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "dnaR-dropdown-multiSelect", 21);
    i0.ɵɵlistener("initialSelectedItemsChange", function ILULeadsDashboardComponent_div_12_Template_dnaR_dropdown_multiSelect_initialSelectedItemsChange_15_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.filter.tags = $event; });
    i0.ɵɵpipe(16, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "a", 22);
    i0.ɵɵlistener("click", function ILULeadsDashboardComponent_div_12_Template_a_click_17_listener() { i0.ɵɵrestoreView(_r15); const ctx_r18 = i0.ɵɵnextContext(); return ctx_r18.applyFilters(); });
    i0.ɵɵtext(18, "Apply Filters");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.showfacilityLocations);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("placeholder", "Select unit type/s")("settings", ctx_r3.filterDropdownSettings)("data", i0.ɵɵpipeBind1(7, 13, ctx_r3.unitTypes$))("initialSelectedItems", ctx_r3.filter.unitTypes);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("placeholder", "Select mobility")("settings", ctx_r3.filterDropdownSettings)("data", ctx_r3.accessibilityRequirements)("initialSelectedItems", ctx_r3.filter.accessibilityRequirements);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("placeholder", "Select tag/s")("settings", ctx_r3.filterDropdownSettings)("data", i0.ɵɵpipeBind1(16, 15, ctx_r3.tags$))("initialSelectedItems", ctx_r3.filter.tags);
} }
function ILULeadsDashboardComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelementStart(1, "div", 25);
    i0.ɵɵelementStart(2, "ilu-leads-dashboard-column", 26);
    i0.ɵɵlistener("onLeadDeleted", function ILULeadsDashboardComponent_div_13_Template_ilu_leads_dashboard_column_onLeadDeleted_2_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(); return ctx_r19.handleOnLeadDeleted($event); })("onLeadArchived", function ILULeadsDashboardComponent_div_13_Template_ilu_leads_dashboard_column_onLeadArchived_2_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.handleOnLeadArchived($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 25);
    i0.ɵɵelementStart(4, "ilu-leads-dashboard-column", 26);
    i0.ɵɵlistener("onLeadDeleted", function ILULeadsDashboardComponent_div_13_Template_ilu_leads_dashboard_column_onLeadDeleted_4_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r22 = i0.ɵɵnextContext(); return ctx_r22.handleOnLeadDeleted($event); })("onLeadArchived", function ILULeadsDashboardComponent_div_13_Template_ilu_leads_dashboard_column_onLeadArchived_4_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r23 = i0.ɵɵnextContext(); return ctx_r23.handleOnLeadArchived($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 25);
    i0.ɵɵelementStart(6, "ilu-leads-dashboard-column", 26);
    i0.ɵɵlistener("onLeadDeleted", function ILULeadsDashboardComponent_div_13_Template_ilu_leads_dashboard_column_onLeadDeleted_6_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r24 = i0.ɵɵnextContext(); return ctx_r24.handleOnLeadDeleted($event); })("onLeadArchived", function ILULeadsDashboardComponent_div_13_Template_ilu_leads_dashboard_column_onLeadArchived_6_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.handleOnLeadArchived($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 25);
    i0.ɵɵelementStart(8, "ilu-leads-dashboard-column", 26);
    i0.ɵɵlistener("onLeadDeleted", function ILULeadsDashboardComponent_div_13_Template_ilu_leads_dashboard_column_onLeadDeleted_8_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r26 = i0.ɵɵnextContext(); return ctx_r26.handleOnLeadDeleted($event); })("onLeadArchived", function ILULeadsDashboardComponent_div_13_Template_ilu_leads_dashboard_column_onLeadArchived_8_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r27 = i0.ɵɵnextContext(); return ctx_r27.handleOnLeadArchived($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 25);
    i0.ɵɵelementStart(10, "ilu-leads-dashboard-column", 26);
    i0.ɵɵlistener("onLeadDeleted", function ILULeadsDashboardComponent_div_13_Template_ilu_leads_dashboard_column_onLeadDeleted_10_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r28 = i0.ɵɵnextContext(); return ctx_r28.handleOnLeadDeleted($event); })("onLeadArchived", function ILULeadsDashboardComponent_div_13_Template_ilu_leads_dashboard_column_onLeadArchived_10_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r29 = i0.ɵɵnextContext(); return ctx_r29.handleOnLeadArchived($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("leadStatus", ctx_r4.ILUStatusEnum.Lead)("columnTitle", "Enquiries")("leadDashboardFilter", ctx_r4.filter)("leadCards", ctx_r4.leadsResult.enquiries.result)("totalCount", ctx_r4.leadsResult.enquiries.totalCount)("loading", ctx_r4.dashboardState === ctx_r4.ILULeadsDashboardState.loading)("canDeleteLeads", ctx_r4.canDeleteLeads);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("leadStatus", ctx_r4.ILUStatusEnum.TourBooked)("columnTitle", "Tour booked")("leadDashboardFilter", ctx_r4.filter)("leadCards", ctx_r4.leadsResult.tourBooked.result)("totalCount", ctx_r4.leadsResult.tourBooked.totalCount)("loading", ctx_r4.dashboardState === ctx_r4.ILULeadsDashboardState.loading)("canDeleteLeads", ctx_r4.canDeleteLeads);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("leadStatus", ctx_r4.ILUStatusEnum.TourCompleted)("columnTitle", "Tour completed")("leadDashboardFilter", ctx_r4.filter)("leadCards", ctx_r4.leadsResult.tourCompleted.result)("totalCount", ctx_r4.leadsResult.tourCompleted.totalCount)("loading", ctx_r4.dashboardState === ctx_r4.ILULeadsDashboardState.loading)("canDeleteLeads", ctx_r4.canDeleteLeads);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("leadStatus", ctx_r4.ILUStatusEnum.Waiting)("columnTitle", "Waiting")("leadDashboardFilter", ctx_r4.filter)("leadCards", ctx_r4.leadsResult.waiting.result)("totalCount", ctx_r4.leadsResult.waiting.totalCount)("loading", ctx_r4.dashboardState === ctx_r4.ILULeadsDashboardState.loading)("canDeleteLeads", ctx_r4.canDeleteLeads);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("leadStatus", ctx_r4.ILUStatusEnum.Confirmed)("columnTitle", "Confirmed")("leadDashboardFilter", ctx_r4.filter)("leadCards", ctx_r4.leadsResult.confirmed.result)("totalCount", ctx_r4.leadsResult.confirmed.totalCount)("loading", ctx_r4.dashboardState === ctx_r4.ILULeadsDashboardState.loading)("canDeleteLeads", ctx_r4.canDeleteLeads);
} }
function ILULeadsDashboardComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelement(1, "div", 28);
    i0.ɵɵelementStart(2, "div", 29);
    i0.ɵɵtext(3, "No leads");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 30);
    i0.ɵɵtext(5, " Begin by creating a new enquiry. You'll then be able to easily");
    i0.ɵɵelement(6, "br");
    i0.ɵɵtext(7, " view and track any enquiries and leads that require action. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ILULeadsDashboardComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelement(1, "div", 28);
    i0.ɵɵelementStart(2, "div", 29);
    i0.ɵɵtext(3, "No results");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 30);
    i0.ɵɵtext(5, " Try removing some filters. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
class ILULeadsDashboardComponent {
    /**
     * Initializes a new instance of the ILULeadsDashboardComponent class.
     *
     * @param independentLivingService - The @see IndependentLivingService service.
     * @param accommodationPreferencesService - The @see AccommodationPreferencesService service.
     * @param snackBar - The @see DnaRSnackBarService service.
     * @param authenticationService - The authentication service.
     * @param downloadFileService - The download file service.
     */
    constructor(independentLivingService, accommodationPreferencesService, snackBarService, authenticationService, downloadFileService, routerState, routerGlobals) {
        this.independentLivingService = independentLivingService;
        this.accommodationPreferencesService = accommodationPreferencesService;
        this.snackBarService = snackBarService;
        this.authenticationService = authenticationService;
        this.downloadFileService = downloadFileService;
        this.routerState = routerState;
        this.routerGlobals = routerGlobals;
        /**
         * Make @see ILUStatusEnum available in the template.
         */
        this.ILUStatusEnum = ILU_status_enum_1.ILUStatusEnum;
        /**
         * Make @see ILULeadsDashboardState available in the template.
         */
        this.ILULeadsDashboardState = ilu_leads_dashboard_state_enum_1.ILULeadsDashboardState;
        /**
         * If true then the filter drawer is open are shown, otherwise filter drawer is close and hidden.
         */
        this.filterDrawerOpen = false;
        /**
         * Settings for the filter dropdowns.
         */
        this.filterDropdownSettings = {
            singleSelection: false,
            idField: "id",
            headerField: 'header',
            textField: "name",
            itemsShowLimit: 1,
            maxHeight: 500,
            addAllOption: false,
            enableCheckAll: false,
        };
        /**
         * The facility locations to display in the filter drop down.
         */
        this.facilityLocations$ = new rxjs_1.BehaviorSubject(null);
        /**
         * true if facility location filter should be shown, otherwise false.
         *
         * Only show facility location filter if there are any. But you don't know if there are any until they are loaded.
         */
        this.showfacilityLocations = true;
        /**
         * The unit types to display in the filter drop down.
         */
        this.unitTypes$ = new rxjs_1.BehaviorSubject(null);
        /**
         * The tags to display in the filter drop down.
         */
        this.tags$ = new rxjs_1.BehaviorSubject(null);
        /**
         * The value of the delete leads permission (leadsDeleteLeads.CanAction).
         */
        this.canDeleteLeads = false;
        /**
         * The value of the modify lead details permission (leadDetails.CanModify).
         */
        this.canModifyLeadDetails = false;
        this.loadLeads = () => {
            this.dashboardState = ilu_leads_dashboard_state_enum_1.ILULeadsDashboardState.loading;
            const params = {
                location: this.filter.facilityLocations,
                unitType: this.filter.unitTypes,
                mobility: this.filter.accessibilityRequirements,
                tag: this.filter.tags,
            };
            this.routerState.go(this.routerGlobals.current, params);
            const iluLeadsDashboardFilter = new ilu_leads_dashboard_filter_dto_1.ILULeadsDashboardFilterDto();
            iluLeadsDashboardFilter.facilityLocations = this.filter.facilityLocations.join(",");
            iluLeadsDashboardFilter.unitTypes = this.filter.unitTypes.join(",");
            iluLeadsDashboardFilter.accessibilityRequirements = this.filter.accessibilityRequirements.join(",");
            iluLeadsDashboardFilter.tags = this.filter.tags.join(",");
            this.independentLivingService.getDashboardLeads(Models_1.Constants.CARDS_NUMBER_TAKE_EACH_TIME, iluLeadsDashboardFilter).then((result) => {
                this.leadsResult = result;
                this.leadsResultFiltered =
                    iluLeadsDashboardFilter.facilityLocations != "" || iluLeadsDashboardFilter.unitTypes != "" || iluLeadsDashboardFilter.accessibilityRequirements != "" || iluLeadsDashboardFilter.tags != "";
                this.setComponentState();
            }, () => {
                this.snackBarService.failure("Unexpected error while loading enquiries.");
            });
        };
        /**
         * Request the user's current canDeleteLeads & canModifyLeadDetails permissions.
         */
        this.requestUserPermissions = () => {
            this.authenticationService
                .userHasPermissionDeferred((x) => {
                return x.leadsDeleteLeads.canAction;
            })
                .then(() => {
                this.canDeleteLeads = true;
            }, () => {
                this.canDeleteLeads = false;
            });
            this.authenticationService
                .userHasPermissionDeferred((x) => {
                return x.leadsDetails.canModify;
            })
                .then(() => {
                this.canModifyLeadDetails = true;
            }, () => {
                this.canModifyLeadDetails = false;
            });
        };
        /**
         * Handles the onLeadDeleted event from the column components.
         *
         * @param leadCard The lead card that was deleted.
         */
        this.handleOnLeadDeleted = (leadCard) => {
            this.setComponentState();
        };
        /**
         * Handles the onLeadArchived event from the column components.
         *
         * @param leadCard The lead card that was archived.
         */
        this.handleOnLeadArchived = (leadCard) => {
            this.setComponentState();
        };
        this.dashboardState = ilu_leads_dashboard_state_enum_1.ILULeadsDashboardState.loading;
        this.leadsResultFiltered = false;
        this.filter = new ilu_leads_dashboard_filter_1.ILULeadsDashboardFilter();
        this.leadsResult = new ilu_leads_dashboard_dto_1.ILULeadsDashboardDto();
        this.leadsResult.hasLeads = false;
        this.leadsResult.enquiries = new batch_result_1.BatchResult();
        this.leadsResult.enquiries.totalCount = 0;
        this.leadsResult.enquiries.result = [];
        this.leadsResult.tourBooked = new batch_result_1.BatchResult();
        this.leadsResult.tourBooked.totalCount = 0;
        this.leadsResult.tourBooked.result = [];
        this.leadsResult.tourCompleted = new batch_result_1.BatchResult();
        this.leadsResult.tourCompleted.totalCount = 0;
        this.leadsResult.tourCompleted.result = [];
        this.leadsResult.waiting = new batch_result_1.BatchResult();
        this.leadsResult.waiting.totalCount = 0;
        this.leadsResult.waiting.result = [];
        this.leadsResult.confirmed = new batch_result_1.BatchResult();
        this.leadsResult.confirmed.totalCount = 0;
        this.leadsResult.confirmed.result = [];
    }
    /**
     * @inheritdoc
     */
    ngOnInit() {
        this.filter.facilityLocations = this.routerGlobals.params.location;
        this.filter.unitTypes = this.routerGlobals.params.unitType;
        this.filter.accessibilityRequirements = this.routerGlobals.params.mobility;
        this.filter.tags = this.routerGlobals.params.tag;
        if (this.filter.facilityLocations.length || this.filter.unitTypes.length || this.filter.accessibilityRequirements.length || this.filter.tags.length) {
            this.openFilterDrawer();
        }
        this.loadLeads();
        this.accommodationPreferencesService.getSelectedFacility().then((result) => {
            this.showfacilityLocations = result.locations && result.locations.length > 0;
            const facilityLocations = result.locations;
            facilityLocations.push({
                id: -1,
                name: "Unknown",
                accommodations: null,
            });
            this.facilityLocations$.next(facilityLocations);
        });
        this.accommodationPreferencesService.getUnitTypesForSelectedFacility().then((result) => {
            const unitTypes = result;
            unitTypes.push({
                id: -1,
                name: "Unknown",
                numberBeds: null,
                priceSetting: null,
                priceSettingDescription: null,
                price: null,
                extraService: null,
                numberRoomsAttached: null,
                features: null,
            });
            this.unitTypes$.next(unitTypes);
        });
        const enquiryAccessibilityRequirementDescription = new enquiryAccessibilityRequirementDescription_pipe_1.EnquiryAccessibilityRequirementDescription();
        this.accessibilityRequirements = [
            { id: 2, name: enquiryAccessibilityRequirementDescription.transform(enquiry_accessibility_requirement_enum_1.EnquiryAccessibilityRequirement.AccessibleUnit) },
            { id: 1, name: enquiryAccessibilityRequirementDescription.transform(enquiry_accessibility_requirement_enum_1.EnquiryAccessibilityRequirement.None) },
            { id: 0, name: enquiryAccessibilityRequirementDescription.transform(enquiry_accessibility_requirement_enum_1.EnquiryAccessibilityRequirement.Unknown) },
        ];
        this.independentLivingService.getAllTagsForFacility().then((result) => {
            //Only load tags that are assigned to any enquiries that are not archived:
            result = result.filter(x => x.isAssigned && !x.hasOnlyArchivedLeads);
            let tags = [];
            tags = this.setTagsHeader(result);
            this.tags$.next(tags);
        });
        this.requestUserPermissions();
    }
    /* Format tags with appropriate header to be used in dropdown: */
    setTagsHeader(unorderedTags) {
        let tags = [];
        unorderedTags.forEach(tag => {
            tags.push({ header: tag.isCustom ? 'Custom' : '', id: tag.id, name: tag.name, isDeleted: tag.isDeleted, isCustom: tag.isCustom });
        });
        //Add 'Untagged' option to the list of filter options just before the Custom tag options:
        let lastCustomTagIndex = tags.findIndex(t => t.header == 'Custom');
        lastCustomTagIndex = lastCustomTagIndex >= 0 ? lastCustomTagIndex : tags.length;
        tags.splice(lastCustomTagIndex, 0, { header: '', id: -1, name: 'Untagged', isDeleted: false, isCustom: false });
        return tags;
    }
    /**
     * Opens the filter drawer.
     */
    openFilterDrawer() {
        this.filterDrawerOpen = true;
    }
    /**
     * Closes the filter drawer.
     */
    closeFilterDrawer() {
        this.filterDrawerOpen = false;
        this.filter.facilityLocations = [];
        this.filter.unitTypes = [];
        this.filter.accessibilityRequirements = [];
        this.filter.tags = [];
        this.applyFilters();
    }
    /**
     * Apply the filters and reloads the ILU leads.
     */
    applyFilters() {
        this.loadLeads();
    }
    /**
     * Exports leads in an excel file.
     */
    exportLeads() {
        const iluLeadsDashboardFilter = new ilu_leads_dashboard_filter_dto_1.ILULeadsDashboardFilterDto();
        iluLeadsDashboardFilter.facilityLocations = this.filter.facilityLocations.join(",");
        iluLeadsDashboardFilter.unitTypes = this.filter.unitTypes.join(",");
        iluLeadsDashboardFilter.accessibilityRequirements = this.filter.accessibilityRequirements.join(",");
        iluLeadsDashboardFilter.tags = this.filter.tags.join(",");
        this.independentLivingService.getLeadsExportReportExcelStream(iluLeadsDashboardFilter).then((response) => {
            const now = new Date();
            this.downloadFileService.downloadFile(response, "LeadsReport-" + now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate() + "_" + now.getHours() + "." + now.getMinutes() + "." + now.getSeconds() + ".xlsx");
        }, () => {
            this.snackBarService.failure("Error occurred while exporting leads");
        });
    }
    /**
     * Determines and sets the appropriate component state.
     */
    setComponentState() {
        if (this.leadsResult.enquiries.result.length +
            this.leadsResult.tourBooked.result.length +
            this.leadsResult.tourCompleted.result.length +
            this.leadsResult.waiting.result.length +
            this.leadsResult.confirmed.result.length) {
            this.dashboardState = ilu_leads_dashboard_state_enum_1.ILULeadsDashboardState.normal;
        }
        else {
            this.dashboardState = ilu_leads_dashboard_state_enum_1.ILULeadsDashboardState.empty;
        }
    }
}
exports.ILULeadsDashboardComponent = ILULeadsDashboardComponent;
ILULeadsDashboardComponent.ɵfac = function ILULeadsDashboardComponent_Factory(t) { return new (t || ILULeadsDashboardComponent)(i0.ɵɵdirectiveInject(i1.IndependentLivingService), i0.ɵɵdirectiveInject(i2.AccommodationPreferencesService), i0.ɵɵdirectiveInject(i3.DnaRSnackBarService), i0.ɵɵdirectiveInject("authentication.service"), i0.ɵɵdirectiveInject("downloadFile.service"), i0.ɵɵdirectiveInject(i4.StateService), i0.ɵɵdirectiveInject(i4.UIRouterGlobals)); };
ILULeadsDashboardComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ILULeadsDashboardComponent, selectors: [["ilu-leads-dashboard"]], decls: 17, vars: 9, consts: [["nav-publisher", "leads", 1, "row", "dna-r", "ilu-lead-dashboard", "leads-dashboard"], [1, "dashboard-header"], [1, "page-header"], [1, "heading"], ["class", "btn btn-clear btn-clear-turquoise", 3, "click", 4, "ngIf"], [1, "buttons"], [1, "btn", "btn-secondary", "btn-small", 3, "click"], ["class", "btn btn-primary btn-small", "href", "/#/independentLiving/createEnquiry", 4, "ngIf"], ["class", "filter-drawer", 4, "ngIf"], ["cdkDropListGroup", "", "class", "row board", 4, "ngIf"], ["class", "dashboard-no-leads", 4, "ngIf"], [1, "btn", "btn-clear", "btn-clear-turquoise", 3, "click"], [1, "icon", "icon-filter-outline"], ["href", "/#/independentLiving/createEnquiry", 1, "btn", "btn-primary", "btn-small"], [1, "icon", "icon-add-outline", "icon-neutral-white"], [1, "filter-drawer"], [1, "filter-container"], ["class", "filter", 4, "ngIf"], [1, "filter"], ["name", "unitTypes", 3, "placeholder", "settings", "data", "initialSelectedItems", "initialSelectedItemsChange"], ["name", "mobility", 3, "placeholder", "settings", "data", "initialSelectedItems", "initialSelectedItemsChange"], ["name", "tags", 3, "placeholder", "settings", "data", "initialSelectedItems", "initialSelectedItemsChange"], [1, "btn", "btn-small", "btn-secondary", 3, "click"], ["name", "locations", 3, "placeholder", "settings", "data", "initialSelectedItems", "initialSelectedItemsChange"], ["cdkDropListGroup", "", 1, "row", "board"], [1, "col-xs-2", "column", "ilu-column"], [3, "leadStatus", "columnTitle", "leadDashboardFilter", "leadCards", "totalCount", "loading", "canDeleteLeads", "onLeadDeleted", "onLeadArchived"], [1, "dashboard-no-leads"], [1, "empty-icon"], [1, "no-leads-text"], [1, "create-enquiry-help-text"]], template: function ILULeadsDashboardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "h1");
        i0.ɵɵtext(5, "Leads");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, ILULeadsDashboardComponent_a_6_Template, 3, 0, "a", 4);
        i0.ɵɵtemplate(7, ILULeadsDashboardComponent_a_7_Template, 3, 0, "a", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 5);
        i0.ɵɵelementStart(9, "a", 6);
        i0.ɵɵlistener("click", function ILULeadsDashboardComponent_Template_a_click_9_listener() { return ctx.exportLeads(); });
        i0.ɵɵtext(10, "Export");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(11, ILULeadsDashboardComponent_a_11_Template, 3, 0, "a", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, ILULeadsDashboardComponent_div_12_Template, 19, 17, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, ILULeadsDashboardComponent_div_13_Template, 11, 35, "div", 9);
        i0.ɵɵtemplate(14, ILULeadsDashboardComponent_div_14_Template, 8, 0, "div", 10);
        i0.ɵɵtemplate(15, ILULeadsDashboardComponent_div_15_Template, 6, 0, "div", 10);
        i0.ɵɵelement(16, "dnaR-back-to-top");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("filter-drawer-open", ctx.filterDrawerOpen);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", !ctx.filterDrawerOpen);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.filterDrawerOpen);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.canModifyLeadDetails);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.filterDrawerOpen);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.dashboardState !== ctx.ILULeadsDashboardState.empty);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.dashboardState === ctx.ILULeadsDashboardState.empty && !(ctx.leadsResult.hasLeads && ctx.leadsResultFiltered));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.dashboardState === ctx.ILULeadsDashboardState.empty && ctx.leadsResult.hasLeads && ctx.leadsResultFiltered);
    } }, directives: [i5.NgIf, i6.DnaRBackToTop, i7.DnaRDropdownMultiSelect, i8.CdkDropListGroup, i9.ILULeadsDashboardColumnComponent], pipes: [i5.AsyncPipe], styles: [".dna-r[_ngcontent-%COMP%] {\n  font-family: 'Source Sans Pro';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n.dna-r[_ngcontent-%COMP%]   .display0[_ngcontent-%COMP%] {\n  font-weight: 600;\n  font-size: 120px;\n  line-height: 130px;\n  letter-spacing: -1.2px;\n}\n.dna-r[_ngcontent-%COMP%]   .display1[_ngcontent-%COMP%] {\n  font-weight: 600;\n  font-size: 72px;\n  line-height: 80px;\n  letter-spacing: -0.72px;\n}\n.dna-r[_ngcontent-%COMP%]   .display2[_ngcontent-%COMP%] {\n  font-weight: 600;\n  font-size: 64px;\n  line-height: 72px;\n  letter-spacing: -0.64px;\n}\n.dna-r[_ngcontent-%COMP%]   .display3[_ngcontent-%COMP%] {\n  font-weight: 600;\n  font-size: 56px;\n  line-height: 64px;\n  letter-spacing: -0.56px;\n}\n.dna-r[_ngcontent-%COMP%]   .display4[_ngcontent-%COMP%] {\n  font-weight: 600;\n  font-size: 48px;\n  line-height: 60px;\n  letter-spacing: -0.96px;\n}\n.dna-r[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%], .dna-r[_ngcontent-%COMP%]   .heading1[_ngcontent-%COMP%] {\n  font-weight: 600;\n  font-size: 30px;\n  line-height: 150%;\n  letter-spacing: 0.075px;\n}\n.dna-r[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%], .dna-r[_ngcontent-%COMP%]   .heading2[_ngcontent-%COMP%] {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n  letter-spacing: 0.048px;\n}\n.dna-r[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%], .dna-r[_ngcontent-%COMP%]   .heading3[_ngcontent-%COMP%] {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 150%;\n  letter-spacing: 0.03px;\n}\n.dna-r[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%], .dna-r[_ngcontent-%COMP%]   .heading4[_ngcontent-%COMP%] {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 150%;\n  letter-spacing: 0.016px;\n}\n.dna-r[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%], .dna-r[_ngcontent-%COMP%]   .heading5[_ngcontent-%COMP%] {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n  letter-spacing: 0.07px;\n}\n.dna-r[_ngcontent-%COMP%]   .text-regular[_ngcontent-%COMP%] {\n  font-family: 'Source Sans Pro';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n.dna-r[_ngcontent-%COMP%]   .text-lead[_ngcontent-%COMP%] {\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 150%;\n}\n.dna-r[_ngcontent-%COMP%]   .text-small[_ngcontent-%COMP%] {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n}\n.dna-r[_ngcontent-%COMP%]   .text-x-small[_ngcontent-%COMP%] {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n}\n.dna-r[_ngcontent-%COMP%]   .text-strikethrough[_ngcontent-%COMP%] {\n  text-decoration-line: line-through;\n}\n.dna-r[_ngcontent-%COMP%]   .text-semibold[_ngcontent-%COMP%] {\n  font-weight: 600;\n}\n.dna-r[_ngcontent-%COMP%]   .text-underline[_ngcontent-%COMP%] {\n  text-decoration-line: underline;\n}\n.dna-r[_ngcontent-%COMP%]   .text-label[_ngcontent-%COMP%] {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n}\n.ilu-lead-dashboard[_ngcontent-%COMP%]   .dashboard-header[_ngcontent-%COMP%]   .page-header[_ngcontent-%COMP%] {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  margin: 0;\n  padding-top: 38px;\n  padding-bottom: 38px;\n}\n.ilu-lead-dashboard[_ngcontent-%COMP%]   .dashboard-header[_ngcontent-%COMP%]   .page-header[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%] {\n  display: flex;\n  align-items: flex-end;\n  gap: 16px;\n}\n.ilu-lead-dashboard[_ngcontent-%COMP%]   .dashboard-header[_ngcontent-%COMP%]   .page-header[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%] {\n  margin: 0;\n}\n.ilu-lead-dashboard[_ngcontent-%COMP%]   .dashboard-header[_ngcontent-%COMP%]   .page-header[_ngcontent-%COMP%]   .buttons[_ngcontent-%COMP%] {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-start;\n  gap: 16px;\n}\n.ilu-lead-dashboard[_ngcontent-%COMP%]   .dashboard-header.filter-drawer-open[_ngcontent-%COMP%]   .page-header[_ngcontent-%COMP%] {\n  padding-bottom: 8px;\n}\n.ilu-lead-dashboard[_ngcontent-%COMP%]   .dashboard-header[_ngcontent-%COMP%]   .filter-drawer[_ngcontent-%COMP%] {\n  display: flex;\n  align-items: flex-end;\n  gap: 16px;\n  padding-bottom: 17px;\n}\n.ilu-lead-dashboard[_ngcontent-%COMP%]   .dashboard-header[_ngcontent-%COMP%]   .filter-drawer[_ngcontent-%COMP%]   .filter-container[_ngcontent-%COMP%] {\n  display: flex;\n  gap: 16px;\n  flex: 1;\n}\n.ilu-lead-dashboard[_ngcontent-%COMP%]   .dashboard-header[_ngcontent-%COMP%]   .filter-drawer[_ngcontent-%COMP%]   .filter-container[_ngcontent-%COMP%]   .filter[_ngcontent-%COMP%] {\n  display: flex;\n  width: 25%;\n  padding: 8px 0px 0px 0px;\n  flex-direction: column;\n  gap: 5px;\n}\n.ilu-lead-dashboard[_ngcontent-%COMP%]   .dashboard-header[_ngcontent-%COMP%]   .filter-drawer[_ngcontent-%COMP%]   .filter-container[_ngcontent-%COMP%]   .filter[_ngcontent-%COMP%]   label[_ngcontent-%COMP%] {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  margin-bottom: 0;\n}\n.ilu-lead-dashboard[_ngcontent-%COMP%]   .dashboard-no-leads[_ngcontent-%COMP%] {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 45px;\n}\n.ilu-lead-dashboard[_ngcontent-%COMP%]   .dashboard-no-leads[_ngcontent-%COMP%]   .empty-icon[_ngcontent-%COMP%] {\n  width: 242px;\n  height: 227.47px;\n  flex-shrink: 0;\n  background-color: none;\n  background-image: url('images/emptyIllustration.svg');\n  background-repeat: no-repeat;\n}\n.ilu-lead-dashboard[_ngcontent-%COMP%]   .dashboard-no-leads[_ngcontent-%COMP%]   .no-leads-text[_ngcontent-%COMP%] {\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 28px;\n  \n  letter-spacing: -0.2px;\n  margin-top: 25px;\n}\n.ilu-lead-dashboard[_ngcontent-%COMP%]   .dashboard-no-leads[_ngcontent-%COMP%]   .create-enquiry-help-text[_ngcontent-%COMP%] {\n  color: #595959;\n}\n.ilu-lead-dashboard[_ngcontent-%COMP%]   .board[_ngcontent-%COMP%] {\n  margin-left: 0px;\n  margin-right: 0px;\n  background: #F5F5F5;\n  border: #D2D2D2;\n}\n.ilu-lead-dashboard[_ngcontent-%COMP%]   .board[_ngcontent-%COMP%]   .column[_ngcontent-%COMP%] {\n  border-left: 1px solid #D2D2D2;\n  border-right: 1px solid #D2D2D2;\n  padding-left: 16px;\n  padding-right: 16px;\n}\n.ilu-lead-dashboard[_ngcontent-%COMP%]   .dashboard-column[_ngcontent-%COMP%] {\n  padding: 0px;\n}\n.ilu-lead-dashboard[_ngcontent-%COMP%]   .dashboard-column[_ngcontent-%COMP%]   .more-items-link[_ngcontent-%COMP%] {\n  cursor: pointer;\n  padding-bottom: 16px;\n}\n.ilu-lead-dashboard[_ngcontent-%COMP%]   .dashboard-column[_ngcontent-%COMP%]   .sortable-container[_ngcontent-%COMP%] {\n  margin: 0px 0px 0px 0px;\n}"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(ILULeadsDashboardComponent, [{
        type: core_1.Component,
        args: [{
                selector: "ilu-leads-dashboard",
                styleUrls: ["./ilu-leads-dashboard.component.less"],
                templateUrl: "./ilu-leads-dashboard.component.html",
            }]
    }], function () { return [{ type: i1.IndependentLivingService }, { type: i2.AccommodationPreferencesService }, { type: i3.DnaRSnackBarService }, { type: undefined, decorators: [{
                type: core_1.Inject,
                args: ["authentication.service"]
            }] }, { type: undefined, decorators: [{
                type: core_1.Inject,
                args: ["downloadFile.service"]
            }] }, { type: i4.StateService }, { type: i4.UIRouterGlobals }]; }, null); })();
